import * as types from '../constants/ActionTypes'

import 'whatwg-fetch';

const server = window.server || "";

//用户注册，订单申请意向
export const doRegister = params =>{
	return dispatch => {
		dispatch({type:types.SET_LOADING,data:true});
		fetch(server + "/v2/sys/join",{
			method: 'POST',
			body: getPostParams(params)
		}).then(res => {
			return res.json();
		}).then(data => {
			dispatch({type:types.SET_LOADING,data:false});
			if(data.status == "true"){
				dispatch(setSuccess(true));
			}else{
				alert('提交失败，请重新提交！');
			}
		}).catch(ex=> {
			console.log('parsing failed', ex)
		});
	}
}

export const setSuccess = bool =>{
	return {type:types.SET_SUCCESS,data:bool}
}

const getPostParams = data => {
	let result = new FormData();
	for (let key in data) {
		if (data.hasOwnProperty(key)) {
			result.append(key, data[key]);
		}
	}
	return result
}


// WEBPACK FOOTER //
// ./project/actions/user.js